import React from 'react';

import { useFeatureDisclaimers } from 'features/content/hooks/use-feature-disclaimers';
import { useStoreContext } from 'features/store';
import { StyleSheet } from 'react-native';

import { NutritionDisclaimer } from 'components/nutrition/nutrition-disclaimer';
import { Box } from 'components/ui/box';
import { Typography } from 'components/ui/typography';

import { SodiumDisclaimerUS } from './sodium-disclaimer';

interface ILegalDisclaimers {
  hideNutritionLegalDisclaimer?: boolean;
}

const LegalDisclaimers = ({ hideNutritionLegalDisclaimer = false }: ILegalDisclaimers) => {
  const { noStoreSelected } = useStoreContext();
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { superUpsell, calorie, itemAvailability } = featureDisclaimers || {};

  return (
    <Box style={styles.container}>
      {noStoreSelected ? (
        <Typography variant="copyTwo" style={styles.itemAvailability}>
          {itemAvailability?.locale}
        </Typography>
      ) : null}
      {!hideNutritionLegalDisclaimer ? (
        <Box testID="wizard-nutrition-disclaimer">
          <NutritionDisclaimer content={superUpsell?.localeRaw} />
          <NutritionDisclaimer content={calorie?.localeRaw} />
        </Box>
      ) : null}
      <SodiumDisclaimerUS />
    </Box>
  );
};

export default LegalDisclaimers;

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  itemAvailability: {
    marginBottom: 16,
  },
});
